import { useEffect, useState, useContext } from "react";
import { IonButton, IonInput, IonModal, IonSelect, IonSelectOption, isPlatform } from "@ionic/react";
import { FilePicker } from '@capawesome/capacitor-file-picker';
import {BhagavatamCotent, IskconContent, Hindit } from "../global";
import { NativeAudio } from '@capacitor-community/native-audio'
import { File } from '@awesome-cordova-plugins/file';
import { Filesystem } from "@capacitor/filesystem";


function AddSongModal(props) {
  const [iskcon, ] = useContext(IskconContent);
  const[singersMap, setSingersMap] = useState({})
  const[englishToHindi, setEnglishToHindi] = useState({})
  const [content2, ] = useContext(BhagavatamCotent)
  const [hindit, ] = useContext(Hindit);
  const [file, setFile] = useState(null)

  const customEnglishSort = (a, b) => {
    const order = ["Srila", "HH", "HG", "Vaishnavas"];
  
    const getPriority = (key) => {
      for (let prefix of order) {
        if (key.startsWith(prefix)) {
          return order.indexOf(prefix);
        }
      }
      return order.length; // If not found in order, place it at the end
    };
  
    const priorityA = getPriority(a);
    const priorityB = getPriority(b);
  
    if (priorityA !== priorityB) {
      return priorityA - priorityB; // Sort by priority
    }
  
    // If priorities are the same, sort lexicographically
    return a.localeCompare(b);
  };
  useEffect(()=>{
    let singersMap = {}
    let englishToHindi = {}
    for (let song of iskcon.songs){
      for(let singer of song.link) {
        let singerName = singer.linkname.slice(0, (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) === -1 ? singer.linkname.length : (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) )
        if(!singersMap[singerName]) singersMap[singerName]=[]
        singersMap[singerName].push({"name": song.name, "path": "/home/songs/"+song.name+"_"+ (song.book ?? "") })
        let hsingerName = singer.hlinkname.slice(0, (singer.hlinkname.indexOf(" (") !== -1 ? singer.hlinkname.indexOf(" (") : singer.hlinkname.indexOf("(")) === -1 ?  singer.hlinkname.length : (singer.hlinkname.indexOf(" (") !== -1 ? singer.hlinkname.indexOf(" (") : singer.hlinkname.indexOf("(")))
        englishToHindi[singerName] = hsingerName
      }
    }
    for (const [i, chap] of content2.chap.entries()) {
      for (const [j, song] of chap.song.entries()) {
        for(let singer of (song.link ?? [])) {
          let singerName = singer.linkname.slice(0, (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) === -1 ? singer.linkname.length : (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) )
          if(!singersMap[singerName]) singersMap[singerName]=[]
          singersMap[singerName].push({"name": song.name.slice(3), "path": `/sb/${i}_${j}` })
          let hsingerName = singer.hlinkname.slice(0, (singer.hlinkname.indexOf(" (") !== -1 ? singer.hlinkname.indexOf(" (") : singer.hlinkname.indexOf("(")) === -1 ?  singer.hlinkname.length : (singer.hlinkname.indexOf(" (") !== -1 ? singer.hlinkname.indexOf(" (") : singer.hlinkname.indexOf("(")))
          englishToHindi[singerName] = hsingerName
        }
      }
    }
    for (let songName of Object.keys(props.addedSongs)) {
      for (let singer of props.addedSongs[songName]) {
        let singerName = singer.singer.slice(0, (singer.singer.indexOf(" (") !== -1 ? singer.singer.indexOf(" (") : singer.singer.indexOf("(")) === -1 ? singer.singer.length : (singer.singer.indexOf(" (") !== -1 ? singer.singer.indexOf(" (") : singer.singer.indexOf("(")) )
        if(!singersMap[singerName]) singersMap[singerName] = []
        singersMap[singerName].push({"name": songName, "path": singer.link})
      }
    }

    const sortedEnglishKeys = Object.keys(singersMap).sort(customEnglishSort);

    const sortedEnglishObject = {};
    sortedEnglishKeys.forEach((key) => {
      sortedEnglishObject[key] = singersMap[key];
    });

  setSingersMap({...sortedEnglishObject})
  setEnglishToHindi({...englishToHindi})
  },[])

function validateSong() {
  if (!props.addSongDetails.singer) {
    props.setToastText("Please provide the singer name");
    props.setShowToast(true);
    return false
  }

  if(props.addSongDetails.singer.indexOf("(") !== -1 || props.addSongDetails.singer.indexOf(")") !== -1){
    props.setToastText("Singer name should not contain brackets");
    props.setShowToast(true);
    return false
  }

  if (!props.addSongDetails.path) {
    if (props.addSongDetails === "file") props.setToastText("Please choose a audio file");
    else props.setToastText("Please provide the song url");
    props.setShowToast(true);
    return false
  }

  if(props.addSongDetails.type==="youtube"){
    const youtubeUrlRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(shorts\/)?(watch\?v=|v\/)|youtu\.be\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/;
    if(!youtubeUrlRegex.test(props.addSongDetails.path)){
      props.setToastText("Please provide a valid youtube url");
      props.setShowToast(true);
      return false
    }
  }

  if(props.addSongDetails.type==="soundcloud"){
    const soundCloudUrlRegex = /^https?:\/\/(?:www\.)?(?:soundcloud\.com|on\.soundcloud\.com)\/.*/;
    if(!soundCloudUrlRegex.test(props.addSongDetails.path)){
      props.setToastText("Please provide a valid soundcloud url");
      props.setShowToast(true);
      return false
    }
  }

  if(props.addSongDetails.type==="mp3") {
    const mp3UrlRegex = /^https?:\/\/.*\.mp3$/;
    if(!mp3UrlRegex.test(props.addSongDetails.path)){
      props.setToastText("Please provide a valid mp3 url");
      props.setShowToast(true);
      return false
    }
  }

  if(props.addSongDetails.type==="drive") {
    const googleDriveUrlRegex = /^https:\/\/drive\.google\.com\/file\/\w+/;
    if(!googleDriveUrlRegex.test(props.addSongDetails.path)){
      props.setToastText("Please provide a valid google drive url");
      props.setShowToast(true);
      return false
    }
  }

  return true

 }

 function getSingerName(actualSingerName) {
  let count = 0
  for (let singer of props.singersList){
    let singerName = singer.linkname.slice(0, (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) === -1 ? singer.linkname.length : (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) )
    if(actualSingerName === singerName) count++
  }
  if(props.addedSongs[props.name]){
    for (let singer of props.addedSongs[props.name]) {
      let singerName  = singer.singer.slice(0, (singer.singer.indexOf(" (") !== -1 ? singer.singer.indexOf(" (") : singer.singer.indexOf("(")) === -1 ? singer.singer.length : (singer.singer.indexOf(" (") !== -1 ? singer.singer.indexOf(" (") : singer.singer.indexOf("(")) )
      if(actualSingerName === singerName) count++
    }
  }
  if(count > 0) {
   return `${actualSingerName} (${count+1})`
  }
  return actualSingerName
 }

 async function addAudioFile() {
  if(props.addSongDetails.type==="file") {
    let filePath = (isPlatform("ios") ? File.documentsDirectory + "Downloads/" : File.dataDirectory) + props.addSongDetails.path
    try{
      await Filesystem.writeFile({
        path: filePath,
        data: file.data
      })
    } catch(err) {
      console.err(err)
      return false
    }
    try{
    await NativeAudio.preload({
      assetId: "localsong",
      assetPath: filePath,
      audioChannelNum: 2,
      isUrl: true
    })
   } catch(err) {
    Filesystem.deleteFile({
      path: filePath
    }).catch((err)=>{
      console.err(err)
    })
    console.err(err)
    props.setToastText("Unable to play the audio file, please choose a another audio file");
    props.setShowToast(true);
    return false
   }
   NativeAudio.unload({
    assetId: 'localsong',
   }).catch((err)=>{})
  }
  return true
 }

    return(
        <IonModal mode="md" isOpen={props.addSong} onIonModalDidDismiss={()=>{props.setAddSong(false)}}>
        <div style={{width:"90vw"}}>

        <div style={{margin: "20px 20px 20px 20px"}}>
        <IonSelect labelPlacement="floating" fill="outline" label="Song Source:" placeholder="Select Source" value={props.addSongDetails.type} onIonChange={(e)=>{
            props.setAddSongDetails(prev=>{
              let dum = {...prev}
              dum["type"] = e.detail.value
              dum["path"] = ""
              return dum
            })
            setFile(null)
          }}>
          <IonSelectOption value="youtube">YouTube</IonSelectOption>
          <IonSelectOption value="soundcloud">SoundCloud</IonSelectOption>
          <IonSelectOption value="drive">Google Drive</IonSelectOption>
          <IonSelectOption value="mp3">MP3 Link</IonSelectOption>
          {!(isPlatform("desktop") || isPlatform("mobileweb")) ? <IonSelectOption value="file">Audio File</IonSelectOption> : null}
        </IonSelect>
      </div>
          <div style={{margin: "10px 20px 20px 20px", display:"flex"}}>
          <IonInput onIonInput={(e)=>{
            props.setAddSongDetails(prev=>{
              let dum = {...prev}
              dum["singer"] = e.detail.value
              return dum
            })
          }} value={props.addSongDetails.singer} 
          labelPlacement="floating"
          fill="outline"
          label="Type the singer name"
          placeholder="Name of the devotee" />
           <IonSelect fill="outline" style={{width: "35%"}} placeholder="select"  value={""} onIonChange={(e)=>{
            props.setAddSongDetails(prev=>{
              let dum = {...prev}
              dum["singer"] = e.detail.value
              return dum
            })
          }}>
          {Object.keys(singersMap).map((key, i)=>{
            return(
          <IonSelectOption key={i} value={key}>{hindit ? (englishToHindi[key] ?? key) : key}</IonSelectOption>
            )
          })}
          {!(isPlatform("desktop") || isPlatform("mobileweb")) ? <IonSelectOption value="file">Audio File</IonSelectOption> : null}
        </IonSelect>
          </div>
          <div style={{margin: "0 20px 0 20px"}}>
            <p style={{margin: "0px"}}>
              {props.addSongDetails.type==="file" ? (!file ? "You can select the song directly from your phone" : (file.name.length > 30 ? file.name.slice(0,30) + "...": file.name)) : null}
            </p>
          </div>
          <div style={{margin: "10px 20px 10px 20px"}}>
          {props.addSongDetails.type==="youtube" ? <IonInput onIonInput={(e)=>{
            props.setAddSongDetails(prev=>{
              let dum = {...prev}
              dum["path"] = e.detail.value.trim();
              return dum
            })
          }} value={props.addSongDetails.path} 
          labelPlacement="floating"
          fill="outline"
          label="Youtube Link"
          helperText="You can paste the YouTube video/shorts song link here" 
          placeholder="e.g., https://www.youtube.com/watch?v=dmo4RQuHuxg"
           /> : null}
          {props.addSongDetails.type==="soundcloud" ? <IonInput onIonInput={(e)=>{
            props.setAddSongDetails(prev=>{
              let dum = {...prev}
              dum["path"] = e.detail.value.trim();
              return dum
            })
          }} value={props.addSongDetails.path} 
          labelPlacement="floating"
          fill="outline"
          label="SoundCloud Link"
          helperText="You can paste the SoundCloud song link here" 
          placeholder="e.g., https://soundcloud.com/the-naay/sri-narasimha-kavacha-stotra"
           /> : null}
           {props.addSongDetails.type==="drive" ? <IonInput onIonInput={(e)=>{
            props.setAddSongDetails(prev=>{
              let dum = {...prev}
              dum["path"] = e.detail.value.trim();
              return dum
            })
          }} value={props.addSongDetails.path} 
          labelPlacement="floating"
          fill="outline"
          label="Google Drive Link"
          helperText="You can paste the Google Drive song link here" 
          placeholder="e.g., https://drive.google.com/file/d/1uP6lkDDnPGirMry0D5thxOqMEmMBVAUi"
           /> : null}
          {props.addSongDetails.type==="mp3" ? <IonInput onIonInput={(e)=>{
            props.setAddSongDetails(prev=>{
              let dum = {...prev}
              dum["path"] = e.detail.value.trim();
              return dum
            })
          }} value={props.addSongDetails.path}
          labelPlacement="floating"
          fill="outline"
          label="MP3 Link"
          helperText="You can paste the MP3 link of audio from websites like ISKCON Desire Tree" 
           placeholder="e.g., https://audio.iskcondesiretree.com/01_-_Srila_Prabhupada/03_-_Japa/SP_02_Japa_by_Example.mp3" /> : null}
          
          {props.addSongDetails.type==="file" ? <IonButton style={{width:"100%"}} onClick={async () => {
              try{
                const result = await FilePicker.pickFiles({
                  multiple: false,
                  readData: true
                });
                if (result.files[0].mimeType.indexOf("audio") === -1){
                  props.setToastText("Please select a valid audio file")
                  props.setShowToast(true)
                  return
                }
                setFile(result.files[0])
                props.setAddSongDetails(prev=>{
                  let dum = {...prev}
                  dum["path"] = (Math.random().toString(36).slice(2, 6).toUpperCase()) + "-" + (result.files[0].name).replace(/\s+/g, '_');
                  return dum
                })
              } catch(err) {
                console.err(err)
              }
            }}>
            {!file ? "Choose Audio File" : "Change Audio File"}
          </IonButton> : null}
          <p style={{fontSize: "11px", textAlign: "center"}}>*This audio will be added locally, and is only visble to you.</p>
          </div>
          <div style={{margin: "10px", textAlign:"center"}}>
            <IonButton onClick={async ()=>{
              let newId = (JSON.parse(JSON.stringify(props.addedSongs))[props.name] ?? []).length
              if(validateSong() && await addAudioFile()){
                props.setAddedSongs((prev)=>{
                  let dum = {...prev}
                  if (!dum[props.name]) dum[props.name] = []
                  let daddSongDetails = {...props.addSongDetails}
                  if (daddSongDetails.type === "drive") {
                    let endPath = daddSongDetails.path.slice(daddSongDetails.path.lastIndexOf("/")+1)
                    if(endPath.indexOf("view") !== -1 || endPath.indexOf("edit") !== -1 || endPath.indexOf("preview") !== -1) {
                      daddSongDetails.path = daddSongDetails.path.slice(0, daddSongDetails.path.lastIndexOf("/"))
                    }
                    daddSongDetails.path = daddSongDetails.path + "/preview"
                  }
                  if (daddSongDetails.type === "soundcloud" || daddSongDetails.type === "drive") daddSongDetails.type = "youtube"
                  daddSongDetails.singer = getSingerName(daddSongDetails.singer)
                  dum[props.name].push(daddSongDetails)
                  props.setUserAudios((prev)=>{
                    let dum = {...prev}
                    dum[props.name] = {"id": newId, "type": daddSongDetails.type , "linkname": daddSongDetails.singer, "hlinkname":daddSongDetails.singer,  "linkaddress": daddSongDetails.path}
                    return dum
                  })
                  return dum
                })
                props.setAddSong(false)
                props.setAddSongDetails(prev=>{
                  let dum = {...prev}
                  dum["type"] = "youtube"
                  dum["singer"] = ""
                  dum["path"] = ""
                  return dum
                })
                setFile(null)
                props.setToastText("You can mange all of your added audios in History tab of Lists section")
                props.setShowToast(true);
              }
            }}>
              Add Audio
            </IonButton>
          </div>
        </div>
      </IonModal>
    );

}

export default AddSongModal;